import React from 'react'
import './Authenticate.css'
import SideNav from '../layout/SideNav'
import Card from '../core/Card'
import LoginPage from './LoginPage'
import Logo from '../core/components/Logo'
import { Col, Checkbox, Button as AButton, Switch, DatePicker, Select, Modal, Input, Icon as AIcon, Tooltip, Form, Alert, Popconfirm, Row, Progress} from 'antd';
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon, ForwardIcon } from '../core/icons'
import { Field, reduxForm, submit, change } from 'redux-form'
import makeField from '../account/makeField'
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Line from '../core/Line'
import { login, redirectAfterOnboarding } from './actions'
import styled from 'styled-components'
import TextAppLink from '../home/TextAppLink'
import { push } from 'react-router-redux'
import { DefaultPlayer as Video } from 'react-html5video';
import AnalyticsHelper from '../utils/AnalyticsHelper'
import CloudEvent from '../utils/CloudEvent'

// STYLES:
import {
  Button,
  Steps,
  StepContainer,
  StepCard,
  TitleRow,
  Content,
  StepProgress
} from './steps/index'

const MobileApp = (props) =>
  <div>
    <Row gutter={20}>
      <Col xs={24} sm={12}>
        <TextAppLink onSubmit={props.onSubmit}/>

      </Col>
      <Col xs={24} sm={12}>
        <Video autoPlay loop muted
           controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
           >
           <source src="https://s3.amazonaws.com/cdn.everlance.com/videos/normal.mp4" type="video/mp4" />
       </Video>

      </Col>
    </Row>
  </div>


const MobileAppStep = (props) =>
<StepContainer>
  <div>
    <StepCard>
      <StepProgress step={3}/>
    </StepCard>

    <StepCard>

      <TitleRow>
        <h3>Text yourself the app</h3>
        <Button link onClick={props.onSubmit}>Skip step</Button>
      </TitleRow>

      <Content spaceOnTop>
        <MobileApp {...props}/>
      </Content>

    </StepCard>
  </div>
</StepContainer>

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    onSubmit: () => {
      dispatch({type: 'FINISH_ONBOARDING'})
      dispatch({
        type: 'SHOW_MODAL',
        modalType: 'NEXT_STEPS_MODAL',
        modalProps: {

        },
        meta: {
          delay: 2000
        }
      })
      dispatch(redirectAfterOnboarding())

      AnalyticsHelper.trackEvent(CloudEvent.OnboardingStep3)

    },

  }
}

export default connect(
  ({models}) => ({

    }),
  mapDispatchToProps )(MobileAppStep)



// WEBPACK FOOTER //
// ./src/user/StepThree.js